import { render, staticRenderFns } from "./CompletedFormsModal.vue?vue&type=template&id=8f3f9104&"
import script from "./CompletedFormsModal.vue?vue&type=script&lang=js&"
export * from "./CompletedFormsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports